/* Constants */

import { SET_CURRENT_PROPERTY } from "./properties"

export const SHOPPING_CART_CHANGE_DATES = 'SHOPPING_CART_CHANGE_DATES'
export const SHOPPING_CART_ADD_ITEM = 'SHOPPING_CART_ADD_ITEM'
export const SHOPPING_CART_UPDATE_ITEM = 'SHOPPING_CART_UPDATE_ITEM'
export const SHOPPING_CART_REMOVE_ITEM = 'SHOPPING_CART_REMOVE_ITEM'
export const SHOPPING_CART_RESET = 'SHOPPING_CART_RESET'

const initialState = {
    startDate: null,
    endDate: null,
    totalPrice: 0,
    rooms: [] // room structure: { id, name, price, count }
}

/* Reducers */

/** @reducer **/
export const shoppingCartReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return {
                ...state,
                totalPrice: 0,
                rooms: []
            }
        case SHOPPING_CART_CHANGE_DATES:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate
            }
        case SHOPPING_CART_ADD_ITEM:
            return {
                ...state,
                rooms: [...state.rooms, action.payload]
            }
        case SHOPPING_CART_UPDATE_ITEM:
            return {
                ...state,
                rooms: state.rooms.map(room => (room.id === action.payload.id ? action.payload : room))
            }
        case SHOPPING_CART_REMOVE_ITEM:
            return {
                ...state,
                rooms: state.rooms.filter(room => room.id !== action.payload.id)
            }
        case SHOPPING_CART_RESET: {
            return initialState
        }
        default:
            return state
    }
}

export const setShoppingCartDates = (startDate, endDate) => dispatch => {
    dispatch(shoppingCartDatesChange(startDate, endDate))
}

export const addToShoppingCart = item => dispatch => {
    dispatch(shoppingCartAddItem(item))
}

export const updateShoppingCartItem = item => dispatch => {
    dispatch(shoppingCartUpdateItem(item))
}

export const removeShoppingCartItem = categoryId => dispatch => {
    dispatch(shoppingCartRemoveItem(categoryId))
}

export const resetShoppingCart = () => dispatch => {
    dispatch(shoppingCartReset())
}

/** @action **/
export const shoppingCartDatesChange = (startDate, endDate) => ({
    type: SHOPPING_CART_CHANGE_DATES,
    payload: { startDate, endDate }
})

/** @action **/
export const shoppingCartAddItem = item => ({
    type: SHOPPING_CART_ADD_ITEM,
    payload: item
})

/** @action **/
export const shoppingCartUpdateItem = item => ({
    type: SHOPPING_CART_UPDATE_ITEM,
    payload: item
})

/** @action **/
export const shoppingCartRemoveItem = categoryId => ({
    type: SHOPPING_CART_REMOVE_ITEM,
    payload: { id: categoryId }
})

/** @action **/
export const shoppingCartReset = () => ({
    type: SHOPPING_CART_RESET
})



// WEBPACK FOOTER //
// ./modules/shoppingCart.js